import { UseQueryOptions } from '@tanstack/react-query'
import { apiGet } from '../axios.config'
import { API_ROUTES } from '../routes'
import { Product } from '../typing'
import { useQueryHook } from './queryHook'

interface IResponse {
  items: Product[]
}

export const useGetDictionaryProducts = (
  publicationGroupId: string,
  productTypeId: string,
  options?: Omit<UseQueryOptions<IResponse>, 'queryKey' | 'queryFn'>,
) => {
  const path = API_ROUTES.DICTIONARY_PRODUCTS

  const queryObject = useQueryHook({
    key: [path, publicationGroupId, productTypeId],
    fetcherFunction: async () => {
      const params = {
        publicationGroupId,
        productTypeId,
      }

      const { data } = await apiGet<object, IResponse>({ path, params })

      return data
    },
    options,
  })

  if (queryObject.isLoading || queryObject.isError) {
    return {
      ...queryObject,
      data: null,
    }
  }

  return {
    ...queryObject,
    data: queryObject.data as IResponse | null,
  }
}
